import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  row-gap: ${props => props.theme.spacing.sp24};
`

export const Step = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr;
  column-gap: ${props => props.theme.spacing.sp16};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 26px;
    top: 0;
    bottom: -${props => props.theme.spacing.sp24};
    width: 2px;
    background: ${props => props.theme.colors.outline.default};
    z-index: 0;
  }

  &:last-child::before {
    bottom: 50%;
  }
`

export const StepMarker = styled.div`
  width: ${props => props.theme.size.XL};
  height: ${props => props.theme.size.XL};
  border-radius: 50%;
  border: ${props => props.theme.stroke.emphasis} solid ${props => props.theme.colors.outline.default};
  color: ${props => props.theme.colors.text.default};
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  z-index: 1;
`

export const StepContent = styled.div`
  margin: 0;
`
